<script lang="ts">
    import {pipe} from 'core/utils';
    import {KpFindInDatabasesPresenter} from './kp-find-in-databases.presenter';
    import {loc} from 'shared/utils/pipes';
    import KpLoadingBlock from 'shared/components/kp-loading/KpLoadingBlock.svelte';
    import {getInjector, getLocalization} from 'core/svelte-context/context';

    export let recordId: string;

    const localize = getLocalization();
    const presenter = getInjector().getByToken<KpFindInDatabasesPresenter>(KpFindInDatabasesPresenter.presenterName);
</script>

{#await presenter.getForeignOccurrences(recordId)}
    <KpLoadingBlock/>
{:then foreignOccurrences}
    <div class="div-databases-list">
        <span>{localize(/* @kp-localization centralIndex.NajdeteVDatabazich */ 'centralIndex.NajdeteVDatabazich')}</span>
        {#each foreignOccurrences as foreignOccurrence}
            <span>
                <a class="btn btn-xs btn-default foreign-database-{foreignOccurrence?.databaseId}"
                   title={foreignOccurrence?.availability?.reasonable && (foreignOccurrence?.availability?.free && 'Volný' || 'Nedostupný') || 'Klikněte pro zjištění dostupnosti'}
                   href={foreignOccurrence?.itemUrl}
                   class:btn-info={(foreignOccurrence?.availability && (!foreignOccurrence?.availability?.reasonable || !foreignOccurrence?.availability?.known))}
                   class:btn-success={(foreignOccurrence?.availability && foreignOccurrence?.availability?.reasonable && foreignOccurrence?.availability?.free)}
                   class:btn-danger={(foreignOccurrence?.availability && foreignOccurrence?.availability?.reasonable && !foreignOccurrence?.availability?.free)}>
                    {pipe(foreignOccurrence?.databaseName, loc())}
                </a>
            </span>
        {/each}
    </div>
{/await}